import React from 'react'
import Drawer from 'material-ui/Drawer'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import CustomersIcon from '@material-ui/icons/Contacts'
// import VendorsIcon from '@material-ui/icons/Business'
import { withStyles } from 'material-ui/styles'
import classNames from 'classnames'
import {
  withRouter
} from "react-router-dom"
import compose from 'lodash/fp/compose'

const drawerWidth = 240;

const styles = theme => ({
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }
});

const NavDrawer = ({ open, classes, theme, history, handleDrawerClose }) =>
  <Drawer
    variant="permanent"
    open={open}
    classes={{
      paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
    }}
  >
  <div className={classes.toolbar}>
    <IconButton onClick={handleDrawerClose}>
      {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
    </IconButton>
  </div>
  <Divider />
  <List>
    <ListItem button onClick={() => history.push('/')}>
      <ListItemIcon>
        <CustomersIcon />
      </ListItemIcon>
      <ListItemText primary="Customers" />
    </ListItem>
    {/* <ListItem button onClick={() => history.push('/vendors')}>
      <ListItemIcon>
        <VendorsIcon />
      </ListItemIcon>
      <ListItemText primary="Vendors" />
    </ListItem> */}
  </List>
  </Drawer>

export default compose(
  withRouter,
  withStyles(styles, { withTheme: true })
)(NavDrawer)


// WEBPACK FOOTER //
// ./src/components/NavDrawer.js